<template>
	<footer class="m-footer" :style="{'margin-top': mt + 'rem'}">
		<!-- <div class="m-footer-line" v-if="isBorder"></div> -->
		<div class="m-footer-grid" v-if="page !== 'contact'">
			<div class="m-footer-left">
				<div class="m-footer-title">DON'T BE A STRANGER.</div>
				<div class="m-footer-desc">
					<p>New pieces, studio happenings, and the</p>
					<p>occasional bit of nonsense we're usually up to.</p>
				</div>
				<div class="m-footer-field">
					<input type="email" class="m-footer-input" placeholder="Your Email Address" v-model="email"
						@keyup.enter="handleSubmit" :disabled="submitting" />
					<div class="m-footer-underline"></div>
				</div>
				<!-- 内联提示消息（移动端小字号） -->
				<p v-if="message" class="m-footer-message" :class="messageType">{{ message }}</p>

				<div class="m-footer-title m-footer-title-gap">STUDIO</div>
				<div class="m-footer-desc" style="margin-top: 10rem;max-width: 150rem;">
					{{ companyAddress }}
				</div>
			</div>

			<div class="m-footer-right">
				<div class="m-footer-title m-footer-right-style">GENERAL ENQUIRES</div>
				<div class="m-footer-desc" style="margin-top: 10rem;">
					<div class="m-footer-link">{{ companyEmail }}</div>
					<div class="m-footer-link" style="text-decoration: none;">{{ companyPhone }}</div>
				</div>

				<div class="m-footer-title m-footer-title-gap" style="margin-top: 54rem;">INSTAGRAM</div>
				<div class="m-footer-desc" style="margin-top: 10rem;">
					<div class="m-footer-link" style="text-decoration: none;">
						<a href="https://www.instagram.com/den_holm/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">{{ instagram1 }}</a>
					</div>
					<div class="m-footer-link" style="text-decoration: none;">
						<a href="https://www.instagram.com/den_holmunited/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">{{ instagram2 }}</a>
					</div>
					<div class="m-footer-link" style="text-decoration: none;">
						<a href="https://www.instagram.com/stevenjohnclark/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">{{ instagram3 }}</a>
					</div>
				</div>
			</div>
		</div>

		<div class="m-footer-grid" v-else>
			<div class="m-footer-left">
				<div class="m-footer-title">STAY IN THE DREAM</div>
				<div class="m-footer-desc">
					Be the first to hear about new collections, studio stories, and the occasional thing we couldn't help but share.
				</div>
				<div class="m-footer-field">
					<input type="email" class="m-footer-input" placeholder="Enter your email" v-model="email"
						@keyup.enter="handleSubmit" :disabled="submitting" />
					<div class="m-footer-underline"></div>
				</div>
				<p v-if="message" class="m-footer-message" :class="messageType">{{ message }}</p>

				<div class="m-footer-title m-footer-right-style" style="margin-top: 42rem;">GENERAL ENQUIRES</div>
				<div class="m-footer-desc" style="margin-top: 10rem;">
					<div class="m-footer-link">{{ companyEmail }}</div>
					<div class="m-footer-link" style="text-decoration: none;">{{ companyPhone }}</div>
				</div>

				<div class="m-footer-title m-footer-title-gap">INSTAGRAM</div>
				<div class="m-footer-desc" style="margin-top: 10rem;">
					<div class="m-footer-link" style="text-decoration: none;">
						<a href="https://www.instagram.com/den_holm/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">{{ instagram1 }}</a>
					</div>
					<div class="m-footer-link" style="text-decoration: none;">
						<a href="https://www.instagram.com/den_holmunited/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">{{ instagram2 }}</a>
					</div>
					<div class="m-footer-link" style="text-decoration: none;">
						<a href="https://www.instagram.com/stevenjohnclark/" target="_blank"
							class="contact-link font-apercu-medium"
							style="display: block;text-decoration: none;">{{ instagram3 }}</a>
					</div>
				</div>

				<div class="m-footer-title m-footer-title-gap">STUDIO</div>
				<div class="m-footer-desc" style="margin-top: 10rem;max-width: 150rem;">
					{{ companyAddress }}
				</div>
			</div>

			<div class="m-footer-right" style="justify-content: flex-end;">
				<img :src="textImg" alt="denHolm" class="m-footer-text-img" />
			</div>
		</div>
	</footer>
</template>

<script>
	import {
		getSiteConfig,
		subscribeEmail
	} from '@/api/content'

	export default {
		name: 'MobileFooter',
		props: {
			mt: {
				type: Number,
				default: 0
			},
			isBorder: {
				type: Boolean,
				default: true
			},
			page: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				textImg: require('@/assets/mobile/contact/textFull.png'),
				email: '',
				submitting: false,
				message: '',
				messageType: '',
				companyEmail: 'info@den-holm.com',
				companyPhone: '+61 422 875 261',
				companyAddress: '12 Fulton Street, Oakleigh South 3167 Victoria, Australia',
				instagram1: '@den_holm',
				instagram2: '@den_holmunited',
				instagram3: '@stevenjohnclark'
			}
		},
		mounted() {
			this.loadSiteConfig()
		},
		methods: {
			isValidEmail(email) {
				const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
				return re.test(email)
			},
			async handleSubmit() {
				this.message = ''
				if (!this.email) {
					this.showMessage('Please enter your email address.', 'error')
					return
				}
				if (!this.isValidEmail(this.email)) {
					this.showMessage('Please enter a valid email address.', 'error')
					return
				}
				if (this.submitting) return
				this.submitting = true

				// try {
				//     const result = await subscribeEmail(this.email)
				//     if (result === true) {
				//         this.showMessage('Subscription successful! Thank you.', 'success')
				//         this.email = ''
				//     } else {
				//         this.showMessage('Subscription failed. Please try again.', 'error')
				//     }
				// } catch (error) {
				//     console.error('Subscription error:', error)
				//     this.showMessage('An error occurred. Please try again.', 'error')
				// } finally {
				//     this.submitting = false
				// }
				try {
					const response = await subscribeEmail(this.email); // 现在 response 是完整的 ReturnModel 对象

					console.log(response)
					if (response && response.retCode === 1) {
						this.showMessage('Subscription successful! Thank you.', 'success')
						this.email = '';
					} else {
						this.showMessage('Subscription failed. Please try again.', 'error')
					}
				} catch (error) {
					console.error('Subscription error:', error);
					this.showMessage('An error occurred. Please try again.', 'error')
				} finally {
					this.submitting = false;
				}
			},
			showMessage(msg, type) {
				this.message = msg
				this.messageType = type
				setTimeout(() => {
					this.message = ''
				}, 3000)
			},
			async loadSiteConfig() {
				try {
					const response = await getSiteConfig()
					const config = response.result

					if (config) {
						this.companyEmail = config.CompanyEmail || this.companyEmail
						this.companyPhone = config.CompanyPhone || this.companyPhone
						this.companyAddress = config.CompanyAddress || this.companyAddress
						this.instagram1 = config.Instagram1 || this.instagram1
						this.instagram2 = config.Instagram2 || this.instagram2
						this.instagram3 = config.Instagram3 || this.instagram3
					}
					console.log(this.companyAddress)
				} catch (error) {
					console.error('Failed to load site config:', error)
				}
			}
		}
	}
</script>

<style scoped>
	.m-footer {
		padding: 18rem 25rem 30rem;
		background: #fff;
		color: #000;
		font-family: 'Apercu-Medium', sans-serif;
		 padding-bottom: 0 !important;
	}

	.m-footer-line {
		height: 1rem;
		background: #000;
		margin-bottom: 23rem;
	}

	.m-footer-grid {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	   /* padding-bottom: 50rem; */
	}

	.m-footer-title {
		font-size: 8rem;
		font-weight: 700;
		letter-spacing: 0.3rem;
	}

	.m-footer-title-gap {
		margin-top: 22rem;
	}

	.m-footer-desc {
		font-size: 8rem;
		margin-top: 10rem;
	}

	.m-footer-field {
		margin-top: 10rem;
	}

	.m-footer-label {
		font-size: 11rem;
	}

	.m-footer-underline {
		margin-top: 6rem;
		height: 1rem;
		background: #000;
		width: 90%;
	}

	.contact-link {
		color: #000;
	}

	.m-footer-link {
		text-decoration: underline;
		text-underline-offset: 2rem;
		margin-top: 4rem;
	}

	.m-footer-right {
		/* display: flex;
		flex-direction: column; */
		width: 25%;
		text-align: left;
		margin-left: 19%;
	}

	.m-footer-right img {
		width: 100%;
		height: 100%;
		/* position: fixed;
		bottom: 50rem;
		right: 10rem; */
	}

	.m-footer-left {
		width: 56%;
		display: flex;
		flex-direction: column;
	}

	.m-footer-right-style {
		/* display: flex; */
		justify-content: flex-start;
	}


	.m-footer-input {
		font-size: 8rem;
		border: none;
		outline: none;
		background: transparent;
		width: 100%;
		color: #000;
		font-family: 'Apercu-Medium', sans-serif;
	}

	.m-footer-input::placeholder {
		color: #000;
	}
</style>